export default __webpack_public_path__ + "static/media/SEO_SVG.27915bc4.svg";